export default "__VITE_ASSET__8cf437b9__"